var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,4.5a2.25,2.25,0,1,0-1.59-.66A2.25,2.25,0,0,0,9,4.5ZM5.65,11.59a1.13,1.13,0,0,0-.79-2.11A7.5,7.5,0,1,0,14.12,20a1.13,1.13,0,0,0-2-1.06,5.25,5.25,0,1,1-6.48-7.38Zm6.53-3.34-.09-.45a2.24,2.24,0,0,0-4.39.87l1.08,5.42a3,3,0,0,0,3,2.41h4.71a.75.75,0,0,1,.7.48l1.7,4.54a1.5,1.5,0,0,0,1.88.9L23,21.67A1.5,1.5,0,1,0,22,18.83l-.87.29L20,15.93a3.75,3.75,0,0,0-3.51-2.43H13.23l-.45-2.25h3a1.5,1.5,0,0,0,0-3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.8bff4168efa70bc7f40ff20617706784.svg";
export { ForwardRef as ReactComponent };